import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home/Home";
import Exam from "../pages/Exam/Exam";
import Login from "../pages/login/Login";
import App from "../pages/app/App";
import ForgotPassword from "../pages/forgot-password/ForgotPassword";
import Groups from "../pages/groups/Group";
import Root from "../pages/app/components/Root";
import Exams from "../pages/Exam/Exam";
import OtpVerify from "../pages/signup/otpVerify";
import SyllabusDetail from "../pages/Exam/[id]/SyllabusDetail";
import SignUp from "../pages/signup/signUp";
import JoinedSyllabus from "../pages/joined-syllabus/JoinedSyllabus";
import JoinedUsers from "../pages/syllabus-joined-users/JoinedUsers";
import Progress from "../pages/progress/Progress";
import JoinedGroup from "../pages/joinedGroups/JoinedGroup";
import AllJoinedGroups from "../pages/joinedGroups/AllJoinedGroups";
import GroupUsers from "../pages/joinedGroups/users/GroupUsers";
import OMR from "../pages/joinedGroups/omr/OMR";
import GroupQuizzes from "../pages/joinedGroups/quizzes/GroupQuizzes";
import GroupDiscussion from "../pages/joinedGroups/discussion/GroupDiscussion";
import AttemptExam from "../pages/attempt-exam/AttemptExam";
import QuizResults from "../pages/joinedGroups/QuizResults/QuizResults";
import ExamAnalysis from "../pages/analysis/exam/ExamAnalysis";
import AttemptOMR from "../pages/attempt-omr/AttemptOMR";
import OmrResults from "../pages/joinedGroups/OmrResults/OmrResults";
import OmrAnalysis from "../pages/analysis/omr/OmrAnalysis";
import ExpertView from "../pages/ExportView/ExpertView";
import ResourceModuleRenderer from "../pages/resources/ResourceModuleRenderer";
import Resources from "../pages/resources/Resources";
import AboutUs from "../pages/AboutUs/AboutUs";
import LandingPage from "../pages/Landing/Landing";

const Routing = ({ originalUrl }) => {
  return (
    <Routes>
      {/* <Route exact path="/" element={<Home originalUrl={originalUrl} />} /> */}
      <Route
        exact
        path="/"
        element={<LandingPage originalUrl={originalUrl} />}
      />
      <Route path="/exam/:id" element={<Exam />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<OtpVerify />} />
      <Route path="/complete-signup" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/expert-view/*" element={<ExpertView />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/:folder/:slug" element={<ResourceModuleRenderer />} />

      {/* <Route path="/app" element={<App />}>
        <Route path="/app" element={<Root />} />
        <Route path="/app/joined-groups" element={<AllJoinedGroups />} />
        <Route path="/app/groups" element={<Groups />} />

        <Route path="/app/groups/:id" element={<JoinedGroup />}>
          <Route path="/app/groups/:id" element={<GroupQuizzes />} />
          <Route path="/app/groups/:id/users" element={<GroupUsers />} />
          <Route path="/app/groups/:id/omr" element={<OMR />} />
          <Route
            path="/app/groups/:id/discussion"
            element={<GroupDiscussion />}
          />
        </Route>

        // Exam
        <Route path="/app/exam-analysis/:id" element={<ExamAnalysis />} />
        <Route path="/app/exam/results/:id" element={<QuizResults />} />
        <Route path="/app/exam-syllabus" element={<Exams />} />
        <Route path="/app/exam-syllabus/:id" element={<SyllabusDetail />} />

        <Route path="/app/omr-analysis/:id" element={<OmrAnalysis />} />
        <Route path="/app/omr/results/:id" element={<OmrResults />} />
        <Route path="/app/attempt-exam/:id" element={<AttemptExam />} />
        <Route path="/app/progress/:id" element={<Progress />} />
        <Route path="/app/joined-users/:id" element={<JoinedUsers />} />
        <Route path="/app/joined-syllabus" element={<JoinedSyllabus />} />
      </Route> */}

      {/* <Route path="/attempt-omr/:id" element={<AttemptOMR />} /> */}
    </Routes>
  );
};

export default Routing;
